<template>
    <div class="d-flex align-center flex-column justify-start fill-height" style="width: 100% !important;">
        <v-container fluid width=100% class="lightgrey pa-5">
            <v-card flat color="lightgrey" height=100%>
                <v-row class="pt-4 px-4">
                    <v-col cols="2"  md="1" lg="1" class="d-flex align-center">
                        <v-row class="">
                            <div v-if="sensors.soil_temp >= 5"> <v-icon size="40" color="success" position="center" class="pl-2">icons8-tractor</v-icon> </div>
                            <div v-else-if="sensors.soil_temp < 5"> <v-icon size="40" color="error" position="center" class="pl-2">icons8-tractor</v-icon> </div>
                            <div v-else> <v-icon size="40" color="grey" position="center" class="pl-2">icons8-tractor</v-icon> </div>
                        </v-row>
                    </v-col>
                    <v-col cols="10" class="d-flex align-center">
                        <div class="">
                            <div v-if="sensors.soil_temp >= 5"> <h3 class="font-weight-normal success--text">{{ $t('menu.muck') }}</h3> </div>
                            <div v-else-if="sensors.soil_temp < 5"> <h3 class="font-weight-normal error--text">{{ $t('menu.muck') }}</h3> </div>
                            <div v-else> <h3 class="font-weight-normal">{{ $t('menu.muck') }}</h3> </div>
                        <div class=""> <h5><span v-if="JSON.stringify(station) !== '{}'">{{ station.station_name }} </span></h5> </div>
                    </div>
                    </v-col>
                </v-row>
            </v-card>
        </v-container>
        <v-row class="pt-3" style="width: 100% !important;">    
            <v-col cols="12" xs="12" sm="6" md="5" lg="4">
                <dashcard :currentdata="currentData.muckPeriod" :key="currentData.componentKey" />
                <dashcard :currentdata="currentData.soilTempDayDegC" :key="currentData.componentKey" />
                <forecast :currentdata="currentData.weatherForecast" :key="currentData.weatherForecast.componentKey" />

                <!-- <v-card flat color="appbackground" width=100% height="130" class="pt-4 pa-2"> 
                    <weatherforecast />
                </v-card>  -->
                <div v-if="sensors.soil_temp >= 5">
                    <v-btn block depressed large @click="MIX_logActivity('muckSpreading', station, currentData), overlay = !overlay" color="success" class="mt-3">{{ $t('buttons.activity') }}</v-btn>
                </div>

                <v-btn block depressed large @click="MIX_go('/farming')" class="mt-3 lightgrey">{{ $t('buttons.back') }}</v-btn>

                <v-overlay :value="overlay">
                    <v-card color="appbackground" flat style="width: 75vw impo !important">
                        <overlay :currentdata="currentData" :key="currentData.componentKey" :showButton="true" />
                        <v-col cols=12 class="">
                            <v-btn block depressed large @click="overlay = false" class="lightgrey darktext--text">{{ $t('buttons.back') }}</v-btn>   
                        </v-col>             
                    </v-card>
                </v-overlay>
                
            </v-col>
        </v-row>
    </div> 
</template>

<script>
// @ is an alias to /src
//
// require('csg-wp-api.node_modules.index.js')
import { mapGetters } from 'vuex'; // Map Actions / Getters
export default {
    name: 'FertiliserSpreading',
    data: () => ({
        station: {},
        current: [], 
        overlay: false,
        sensors: {
            soil_temp: '-',
            //create all of the sensor values
        },
        currentData: {
            activity: {
                title: 'menu.muck'
            },
            muckPeriod: {
                title: 'weather.muckSpreadingPeriod.title',
                subtitle: 'weather.muckSpreadingPeriod.date',
                icon: 'icons8-calendar',
                value: 'weather.muckSpreadingPeriod.state',
                status: 'success',
                componentKey: 0,
            },
            soilTempDayDegC: {
                title: 'weather.soilTemperature',
                subtitle: '16th of Jan - 14th of Sep',
                unit: "°C",
                icon: 'icons8-temperature',
                value: '-',
                status: 'grey',
                componentKey: 1,
            },
            weatherForecast: {
                value: [],
                componentKey: 2
            }
        }
    }),
    computed: {
        ...mapGetters({
                GET_weatherDataStations: 'GET_weatherDataStations',
                GET_weatherDataStationById: 'GET_weatherDataStationById',
                GET_weatherDataCurrent: 'GET_weatherDataCurrent',
        }),
    },
    methods: {
        convertToCelcius: function (value) {
          if (!value) return ''
          return parseFloat(((5/9) * (parseFloat(value) - 32)).toFixed())
        },  
        getSensor: function(sensor_type) {
            return this.current.find(sensor => parseInt(sensor.sensor_type) === parseInt(sensor_type) )
        },
        updateSensors() {
            var t = this;    
            var soil_temp = parseFloat(t.getSensor(105).data[0].temp_last)        
            t.sensors.soil_temp = t.convertToCelcius(soil_temp);  
            t.sensors.soil_tempUpdated = t.getSensor(105).data[0].ts;
        },
        updateSoilTempDayDegC() {
            var t = this;
            t.currentData.soilTempDayDegC.value = t.convertToCelcius(parseFloat(t.getSensor(105).data[0].temp_last))
            t.currentData.soilTempDayDegC.subtitle = t.MIX_formatDateTime(t.getSensor(105).data[0].ts, 'X', 'DD-MMM-YY HH:mm:ss')
            if (t.currentData.soilTempDayDegC.value >= 5) {
                t.currentData.soilTempDayDegC.status = 'success'
            } else {
                t.currentData.soilTempDayDegC.status = 'error'
            }
            t.currentData.soilTempDayDegC.componentKey++
        },
        updateForecast: async function(lat, lon) {
            var t = this;
            var forecastResult = await t.MIX_weatherDataForecast(lat, lon)
            t.currentData.weatherForecast.value = forecastResult.data.daily
            t.currentData.weatherForecast.componentKey++
            // console.log("weather = " + JSON.stringify(t.currentData.weatherForecast.value))
        },
    },
    async mounted () {
        var t = this;
        var routerPath = t.$route.path.split('/')
        var stationId = routerPath[2];
        t.station = await t.GET_weatherDataStationById(stationId);
        await t.MIX_weatherDataCurrent(stationId) 
        t.current = await t.GET_weatherDataCurrent;
        console.log('got here')
        t.updateSensors();
        t.updateSoilTempDayDegC();
        t.updateForecast(t.station.latitude, t.station.longitude);

    }
  }
</script>